import React, { Component } from 'react';
// import Grid from '@material-ui/core/Grid';
// import Button from '@material-ui/core/Button';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import ContactComment from './ContactComment.js';
import ContactName from './ContactName';
import ContactCompany from './ContactCompany';
import ContactEmail from './ContactEmail';
import '../style/App.css';

//required Props include:
// - this.props.handle<Comment/Name/etc>(value) (received from child, set to state)
// - this.props.commentTitle (title of TextField, passed down to child)
//


class LandingContact extends Component {
  constructor(props) {
    super(props)
    this.state = {
      name: '',
      company: '',
      email: '',
      comment: '',
      contactFormHeader: 'Contact Us',
      showComment: false,
      showForm: true,
      formSubmitted: 'The form was successfully submitted.'
    }
    this.checkState = this.checkState.bind(this);
    this.handleName = this.handleName.bind(this);
    this.handleCompany = this.handleCompany.bind(this);
    this.handleEmail = this.handleEmail.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleComment = this.handleComment.bind(this);
  }

  checkState() {
    console.log('state in LandingContact: ', this.state);
  }

  handleName(value) {
    this.setState({
      name: value
    })
  }
  handleCompany(value) {
    this.setState({
      company: value
    })
  }
  handleEmail(value) {
    this.setState({
      email: value
    })
  }
  handleComment(value) {
    this.setState({
      comment: value
    })
  }
  handleSubmit() {
    let name = this.state.name;
    let company = this.state.company;
    let email = this.state.email;
    let comment = this.state.comment;
    if (this.state.name !== '') {
        // console.log('1 -- pre landingForm prop in LandingContact');
        this.props.landingForm(name, company, email, comment);
        this.setState({
          name: '',
          company: '',
          email: '',
          comment: '',
          contactFormHeader: 'Thanks.',
          showForm: false
        })
        // console.log('2 -- post landingForm prop in LandingContact');
    } else {
      alert('name and/or company not filled out');
    }
  }

  componentDidMount() {
    console.log('compDidMt in LandingContact - PROPS: ', this.props);
    if (this.props.emailAddress) {
      console.log('email: ', this.props.emailAddress)
      this.setState({
        email: this.props.emailAddress
      })
    }
    //app renders textfield based upon the props, which tell it what to renders
    //must receive props from parent, like below, in order to properly render textfields and collect data
    if (this.props.textFields !== undefined) {
      console.log('contactFormHeader FROM props.textFields.commentTitle: ', this.props.textFields);
      if (this.props.textFields.commentTitle !== undefined) {
        console.log('setting state as contactFormHeader: ', this.props.textFields.commentTitle);
        this.setState({
          contactFormHeader: this.props.textFields.commentTitle
        })
      } else { null }
      if (this.props.textFields.showForm === false) {
        this.setState({
          showForm: false
        })
      }
      if (this.props.textFields.formSubmitted !== undefined) {
        this.setState({
          formSubmitted: this.props.textFields.formSubmitted
        })
      }
      if (this.props.textFields.showComment === true) {
        this.setState({
          showComment: true
        })
      }
      if (this.props.textFields.showName === true) {
        this.setState({
          showName: true
        })
      }
      if (this.props.textFields.showEmail === true) {
        this.setState({
          showEmail: true
        })
      }
      if (this.props.textFields.showCompany === true) {
        this.setState({
          showCompany: true
        })
      }
    }
  }

  render() {
    return (
      <div className='contactHolder' onClick={() => this.checkState()}>
        <Grid container spacing={3}>
          <Grid size={{ xs: 12 }} style={{textAlign: 'center'}}>
            <div className='contactFormHolder landingFormHolder feedbackFormCard'>
              <h1 style={{position: 'relative', top: '-18px', color: 'rgb(150, 150, 150)'}}>{this.state.contactFormHeader}</h1>
              { this.state.showForm === true ?
                <form className='contactForm' noValidate autoComplete="off">
                  <div className='contactInfo landingFormContactInfo'>
                    { this.state.showName === true ?
                      <div style={{paddingBottom: '8px'}}>
                          <ContactName name={this.state.name} handleName={(value) => this.handleName(value)}/>
                      </div>
                      :
                      null
                    }
                    { this.state.showCompany === true ?
                      <div style={{paddingBottom: '8px'}}>
                          <ContactCompany company={this.state.company} handleCompany={(value) => this.handleCompany(value)}/>
                      </div>
                      :
                      null
                    }
                    { this.state.showEmail === true ?
                      <div style={{paddingBottom: '8px'}}>
                          <ContactEmail email={this.state.email} handleEmail={(value) => this.handleEmail(value)}/>
                      </div>
                      :
                      null
                    }
                    { this.state.showComment === true ?
                      <div className='' style={{paddingBottom: '8px'}}>
                          <ContactComment comment={this.state.comment} commentTitle={this.props.textFields.commentTitle} handleComment={(value) => this.handleComment(value)}/>
                      </div>
                      :
                      null
                    }
                  </div>
                </form>
                :
                <p>{this.state.formSubmitted}</p>
              }
              {this.state.showForm === true ?
                <div>
                  <p style={{textAlign: 'right', marginBottom: '-4px', marginTop: '-10px', paddingRight: '10px', fontSize: '12px'}}>* denotes required field</p>
                  <div style={{textAlign: 'right', width: '100%'}}>
                    <Button className='contactFormButton' size="large" variant='outlined' style={{backgroundColor: 'white', color: 'rgb(173,0,51)', borderColor: 'rgb(173,0,51)', margin: '10px 10px', width: '80px'}} onClick={() => this.handleSubmit()}>
                      Submit
                    </Button>
                  </div>
                </div>
                :
                null
              }

            </div>
          </Grid>
        </Grid>
      </div>
    )
  }

}

export default LandingContact;
